<template>
    <Modal :title="title" :onClose="onClose">
        {{ message }}
    </Modal>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent } from 'vue';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'ErrorModal',
        methods: { t },
        components: { Modal },
        props: { title: String, message: String, onClose: Function },
    });
</script>
